/** Message keys the UI builds from ids. Listed here so tests can check they all exist. */
import { MessageKey } from '../i18n';
import { ScreenId } from './logic/screens';
import { BIKES, HELMETS, KITS } from './logic/livery';

export const SCREEN_HELP: Record<ScreenId, MessageKey> = {
  loading: 'help.loading', start: 'help.start', levels: 'help.levels', drills: 'help.drills', garage: 'help.garage',
  intro: 'help.intro', play: 'help.play', pause: 'help.pause', settings: 'help.settings', results: 'help.results',
  credits: 'help.credits',
};

export const bikeKey = (id: string) => `livery.bike.${id}` as MessageKey;
export const kitKey = (id: string) => `livery.kit.${id}` as MessageKey;
export const helmetKey = (id: string) => `livery.helmet.${id}` as MessageKey;
export const LIVERY_KEYS: MessageKey[] = [...BIKES.map((b) => bikeKey(b.id)), ...KITS.map((k) => kitKey(k.id)), ...HELMETS.map((k) => helmetKey(k.id))];

export const TIPS: MessageKey[] = ['ui.tip.1', 'ui.tip.2', 'ui.tip.3', 'ui.tip.4', 'ui.tip.5'];
